import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Auth APIs
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  getMe: () => api.get('/auth/me'),
  changePassword: (data) => api.put('/auth/change-password', data),
};

// User APIs
export const userAPI = {
  createUser: (userData) => api.post('/users', userData),
  getAllUsers: (params) => api.get('/users', { params }),
  getUserById: (id) => api.get(`/users/${id}`),
  updateUser: (id, userData) => api.put(`/users/${id}`, userData),
  deleteUser: (id) => api.delete(`/users/${id}`),
};

// Vehicle APIs
export const vehicleAPI = {
  checkIn: (vehicleData) => {
    // For FormData, we need to remove Content-Type header to let browser set it with boundary
    return api.post('/vehicles/checkin', vehicleData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  checkOut: (id) => api.put(`/vehicles/checkout/${id}`),
  getAllVehicles: (params) => api.get('/vehicles', { params }),
  getVehicleById: (id) => api.get(`/vehicles/${id}`),
  getActiveVehicles: () => api.get('/vehicles/active'),
  getStats: () => api.get('/vehicles/stats'),
  searchVehicle: (vehicleNumber) => api.get(`/vehicles/search/${vehicleNumber}`),
};

// Society APIs
export const societyAPI = {
  createSociety: (societyData) => api.post('/societies', societyData),
  getAllSocieties: (params) => api.get('/societies', { params }),
  getSocietyById: (id) => api.get(`/societies/${id}`),
  updateSociety: (id, societyData) => api.put(`/societies/${id}`, societyData),
  deleteSociety: (id) => api.delete(`/societies/${id}`),
  getSocietyUsers: (id, params) => api.get(`/societies/${id}/users`, { params }),
};

// OTP APIs
export const otpAPI = {
  sendOTP: (data) => api.post('/otp/send', data),
  verifyOTP: (data) => api.post('/otp/verify', data),
  resendOTP: (data) => api.post('/otp/resend', data),
};

export default api;
